import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '1',
  title: 'ELEGÍS TU SESIÓN',
  text: 'Seleccionás el nivel del Método Llave que más resuena con lo que estás transitando. Si no sabés cuál elegir, la Depuración Esencial es siempre el punto de entrada natural.'
}, {
  number: '2',
  title: 'ME ESCRIBÍS Y AGENDAMOS',
  text: 'Los turnos los manejo personalmente. Me contactás, coordinamos la fecha y te confirmo la disponibilidad.'
}, {
  number: '3',
  title: 'ME COMPARTÍS TU INTENCIÓN',
  text: 'Antes de la sesión te voy a preguntar qué es lo que querés trabajar. No necesitás tener todo claro. Solo lo que sentís que está pesando — lo que te trajo hasta acá. Tu intención abre la puerta.'
}, {
  number: '4',
  title: 'CONFIRMÁS CON EL PAGO',
  text: 'El turno queda reservado una vez realizado el pago — que debe efectuarse antes de las 24 horas previas a la fecha elegida. El pago anticipado confirma tu intención. Y en este tipo de trabajo, la intención importa.'
}, {
  number: '5',
  title: 'EL TRABAJO OCURRE',
  text: 'No necesitás hacer nada. No necesitás estar en ningún estado especial. El trabajo se realiza sobre tu campo independientemente de lo que estés haciendo ese día.'
}, {
  number: '6',
  title: 'RECIBÍS TU AUDIO',
  text: 'A la tarde del día de tu sesión recibís tu devolución en audio. Todo lo que encontré, lo que se trabajó, lo que se liberó y lo que tu campo tiene para decirte. Escuchalo cuando estés listo/a. Volvé a él cuantas veces lo necesités.'
}];
export function HowItWorks() {
  return <section className="w-full bg-cream py-24 px-6" data-id="element-175">
      <div className="max-w-4xl mx-auto" data-id="element-176">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-teal text-3xl md:text-4xl lg:text-5xl text-center mb-20" data-id="element-177">
          ¿Cómo funciona una sesión?
        </motion.h2>

        <div className="space-y-16 relative before:absolute before:inset-0 before:ml-6 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-teal/20" data-id="element-178">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-179">
              <div className="flex items-center justify-center w-12 h-12 rounded-full border-2 border-teal bg-cream text-teal font-serif text-xl shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-sm z-10" data-id="element-180">
                {step.number}
              </div>

              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] p-6 rounded-2xl bg-white shadow-sm border border-teal/10" data-id="element-181">
                <h3 className="font-serif text-teal-dark tracking-widest uppercase text-sm mb-3" data-id="element-182">
                  Paso {step.number} — {step.title}
                </h3>
                <p className="text-gray-600 font-light leading-relaxed" data-id="element-183">
                  {step.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}